import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login/Login.vue'
import Home from '../views/Home/Home.vue'
import store from '../store'

const SignIn = () => import(/* webpackChunName: 'signin' */ './../views/Login/compinent/SignIn.vue')
const ChangePassword = () => import(/* webpackChunName: 'ChangePassword' */ './../views/Login/compinent/ChangePassword.vue')
const HomeAccount = () => import(/* webpackChunName: 'Account' */ './../views/Functional/Account/Account.vue')
const HomeHome = () => import(/* webpackChunName: 'Home_home' */ './../views/Functional/Home/Home.vue')
const HomeJurisdiction = () => import(/* webpackChunName: 'HomeJurisdiction' */ './../views/Functional/Jurisdiction/Jurisdiction.vue')
const HomeMaterialCategory = () => import(/* webpackChunName: 'HomeMaterialCategory' */ './../views/Functional/MaterialClassification/MaterialCategory.vue')
const HomeMiddleCategories = () => import(/* webpackChunName: 'HomeMiddleCategories' */ './../views/Functional/MaterialClassification/MiddleCategories.vue')
const HomeMaterialSubgroup = () => import(/* webpackChunName: 'HomeMaterialSubgroup' */ './../views/Functional/MaterialClassification/MaterialSubgroup.vue')
const HomePriceRules = () => import(/* webpackChunName: 'HomePriceRules' */ './../views/Functional/PriceRules/PriceRules.vue')
const HomePriceEntry = () => import(/* webpackChunName: 'HomePriceEntry' */ './../views/Functional/PriceRules/PriceEntry.vue')
const HomeCustomerList = () => import(/* webpackChunName: 'HomeCustomerList' */ './../views/Functional/Customer/CustomerList.vue')
const HomeCustomerService = () => import(/* webpackChunName: 'HomeCustomerService' */ './../views/Functional/Customer/CustomerService.vue')
const HomeHelpCenter = () => import(/* webpackChunName: 'HomeHelpCenter' */ './../views/Functional/Customer/HelpCenter.vue')
const HomeMaterialInformation = () => import(/* webpackChunName: 'HomeMaterialInformation' */ './../views/Functional/MaterialClassification/MaterialInformation.vue')
const HomeAppletOrder = () => import(/* webpackChunName: 'HomeAppletOrder' */ './../views/Functional/Order/AppletOrder.vue')
const HomeMiscellaneous = () => import(/* webpackChunName: 'HomeMiscellaneous' */ './../views/Functional/Miscellaneous/Miscellaneous.vue')
const HomeFreight = () => import(/* webpackChunName: 'HomeFreight' */ './../views/Functional/PriceRules/Freight.vue')
const HomeQuantitativeRules = () => import(/* webpackChunName: 'HomeQuantitativeRules' */ './../views/Functional/MaterialClassification/QuantitativeRules.vue')
const HomePETRules = () => import(/* webpackChunName: 'HomePETRules' */ './../views/Functional/PriceRules/PETRules.vue')
const HomeNonStandard = () => import(/* webpackChunName: 'HomePETRules' */ './../views/Functional/Miscellaneous/NonStandard.vue')
const HomeBillingType = () => import(/* webpackChunName: 'HomePETRules' */ './../views/Functional/PriceRules/BillingType.vue')
const HomeDataSyncPlan = () => import(/* webpackChunName: 'HomePETRules' */ './../views/Functional/DataSync/BaseSet/index.vue')
const HomeWxBCOde = () => import(/* webpackChunName: 'HomePETRules' */ './../views/Functional/WxCode/index.vue')
const HomeAddressSync = () => import(/* webpackChunName: 'HomePETRules' */ './../views/Functional/DataSync/AddressSync/index.vue')

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'login',
  component: Login,
  children: [{
    path: '',
    name: 'SignIn',
    component: SignIn
  },
  {
    path: '/changepassword',
    name: 'changepassword',
    component: ChangePassword,
    beforeEnter: (to, from, next) => {
      if (from.name === 'SignIn') {
        next()
      } else {
        next('')
      }
    }
  }
  ]
},
{
  path: '/Home',
  name: 'home',
  component: Home,
  meta: { requiresAuth: true },
  children: [{
    path: '/',
    name: 'Home_home',
    component: HomeHome
  }, {
    path: '/SyS/account',
    name: 'Home_Account',
    component: HomeAccount
  }, {
    path: '/Jurisdiction',
    name: 'Home_Jurisdiction',
    component: HomeJurisdiction
  }, {
    path: '/MaterialCategory',
    name: 'Home_MaterialCategory',
    component: HomeMaterialCategory
  }, {
    path: '/MiddleCategories',
    name: 'Home_MiddleCategories',
    component: HomeMiddleCategories
  }, {
    path: '/MaterialSubgroup',
    name: 'Home_MaterialSubgroup',
    component: HomeMaterialSubgroup
  }, {
    path: '/PriceRules',
    name: 'Home_PriceRules',
    component: HomePriceRules
  }, {
    path: '/PriceEntry',
    name: 'Home_PriceEntry',
    component: HomePriceEntry
  }, {
    path: '/CustomerList',
    name: 'Home_CustomerList',
    component: HomeCustomerList
  }, {
    path: '/CustomerService',
    name: 'Home_CustomerService',
    component: HomeCustomerService
  }, {
    path: '/HelpCenter',
    name: 'Home_HelpCenter',
    component: HomeHelpCenter
  }, {
    path: '/MaterialInformation',
    name: 'Home_MaterialInformation',
    component: HomeMaterialInformation
  }, {
    path: '/AppletOrder',
    name: 'Home_AppletOrder',
    component: HomeAppletOrder
  }, {
    path: '/Miscellaneous',
    name: 'Home_Miscellaneous',
    component: HomeMiscellaneous
  }, {
    path: '/Freight',
    name: 'Home_Freight',
    component: HomeFreight
  }, {
    path: '/QuantitativeRules',
    name: 'Home_QuantitativeRules',
    component: HomeQuantitativeRules
  }, {
    path: '/PETRules',
    name: 'Home_PETRules',
    component: HomePETRules
  }, {
    path: '/NonStandard',
    name: 'Home_NonStandard',
    component: HomeNonStandard
  }, {
    path: '/BillingType',
    name: 'Home_BillingType',
    component: HomeBillingType
  }, {
    path: '/DataSyncPlan',
    name: 'Home_DataSyncPlan',
    component: HomeDataSyncPlan
  }, {
    path: '/WxBCOde',
    name: 'Home_WxBCOde',
    component: HomeWxBCOde
  }, {
    path: '/AddressSync',
    name: 'Home_AddressSync',
    component: HomeAddressSync
  }]
}
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('token')
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
  const TopMenu = JSON.parse(sessionStorage.getItem('TopMenu'))
  const MenuList = JSON.parse(sessionStorage.getItem('MenuList'))
  // const token = localStorage.getItem('token')
  // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  // const TopMenu = JSON.parse(localStorage.getItem('TopMenu'))
  // const MenuList = JSON.parse(localStorage.getItem('MenuList'))
  if (token !== '' && token !== null) {
    store.commit('setToken', token)
    store.commit('setIsLogin', true)
    store.commit('setUserInfo', userInfo)
    store.commit('setTopMenu', TopMenu)
    store.commit('setMenuList', MenuList)
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const isLogin = store.state.isLogin
    if (isLogin) {
      // 已经登录的状态
      // 权限判断,meta元数据
      if (to.name === 'Home_home') {
        next()
      } else {
        const menulist = store.state.MenuList
        let isJurisdiction = false
        if (menulist.length > 0) {
          for (let i = 0; i < menulist.length; ++i) {
            for (let j = 0; j < menulist[i].subsetlist.length; ++j) {
              for (let k = 0; k < menulist[i].subsetlist[j].subsetlist.length; ++k) {
                if (to.name === menulist[i].subsetlist[j].subsetlist[k].Menu_UrlName) { isJurisdiction = true }
              }
            }
          }
        } else {
          next('/Home')
        }
        if (isJurisdiction) { // 表示有权限
          next()
        } else {
          next('/Home')
        }
      }
    } else {
      next('/')
    }
  } else {
    next()
  }
})

export default router
